import { styled } from '@mui/material/styles';
import { Button } from '@mui/material';
import { darkenHexColor, getFontFamily, getThemeColor } from '../../../utils/styleUtils';

export const StyledButton = styled(Button)(
  ({
    variant,
    buttoncolor,
    hovercolor,
    backgroundcolor,
    textposition,
    fontFamily,
    fontWeight,
    hoverBottomBorderColor,
    hoverBottomBorderSize,
    theme,
  }) => ({
    ...(buttoncolor && buttoncolor.startsWith('#') && variant === 'contained'
      ? {
          backgroundColor: buttoncolor,
          '&:hover': {
            backgroundColor: hovercolor || darkenHexColor(buttoncolor),
          },
        }
      : {}),
    ...(buttoncolor && buttoncolor.startsWith('#') && variant === 'outlined'
      ? {
          borderColor: buttoncolor,
          color: buttoncolor,
          ...(backgroundcolor && { backgroundColor: backgroundcolor }),
          '&:hover': {
            borderColor: hovercolor || darkenHexColor(buttoncolor),
            color: hovercolor || darkenHexColor(buttoncolor),
            ...(backgroundcolor && {
              backgroundColor: darkenHexColor(backgroundcolor),
            }),
          },
        }
      : {}),
    ...(buttoncolor && buttoncolor.startsWith('#') && variant === 'text'
      ? {
          color: buttoncolor,
          '&:hover': {
            color: hovercolor || darkenHexColor(buttoncolor),
          },
        }
      : {}),
    ...(variant && variant === 'text'
      ? {
          padding: 0,
          ...(hoverBottomBorderColor
            ? {
                boxShadow: `inset 0 -${hoverBottomBorderSize} 0 0 ${getThemeColor(hoverBottomBorderColor, theme)}`,
                borderRadius: 0,
              }
            : {}),
        }
      : {}),
    ...(fontFamily
      ? {
          fontFamily: getFontFamily(fontFamily, theme),
        }
      : {}),
    ...(fontWeight
      ? {
          fontWeight: fontWeight,
        }
      : {}),
    textTransform: 'none',
    justifyContent: textposition,
  }),
);
